module.exports = __webpack_public_path__ + "img/banking-icon-main.cfc4859.webp";